import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './root'

export const indexRoute = createRoute({
  path: '/',
  getParentRoute: () => rootRoute,
  beforeLoad: () => {
    throw redirect({ to: '/daily-card' })
  },
  component: () => null,
})
